import React from 'react';
export function SocialProof() {
  const testimonials = [{
    quote: 'En 3 meses pasamos de 40% de ocupación entre semana a 85%. El sistema de reservas cambió todo.',
    author: 'Carlos M.',
    restaurant: 'Restaurante La Hacienda, Houston TX'
  }, {
    quote: 'Antes dependíamos del tráfico peatonal. Ahora el 70% de nuestros clientes reservan online antes de llegar.',
    author: 'María G.',
    restaurant: 'Taquería El Sol, Miami FL'
  }, {
    quote: 'El programa de fidelización nos generó un 40% más de visitas repetidas en el primer trimestre.',
    author: 'Roberto S.',
    restaurant: 'Mariscos Don Pedro, Los Angeles CA'
  }];
  return <section className="py-16 bg-[#0a0a0a] border-b border-gray-900" data-id="element-214">
      <div className="max-w-7xl mx-auto px-4" data-id="element-215">
        {/* Stats Bar */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16 text-center border-b border-gray-800 pb-12" data-id="element-216">
          <div data-id="element-217">
            <div className="text-3xl md:text-4xl font-black text-gold mb-2" data-id="element-218">
              +150
            </div>
            <div className="text-sm text-gray-400 font-medium uppercase tracking-wider" data-id="element-219">
              Restaurantes Transformados
            </div>
          </div>
          <div data-id="element-220">
            <div className="text-3xl md:text-4xl font-black text-gold mb-2" data-id="element-221">
              +$2M
            </div>
            <div className="text-sm text-gray-400 font-medium uppercase tracking-wider" data-id="element-222">
              En Ventas Generadas
            </div>
          </div>
          <div data-id="element-223">
            <div className="text-3xl md:text-4xl font-black text-gold mb-2" data-id="element-224">
              4.9/5
            </div>
            <div className="text-sm text-gray-400 font-medium uppercase tracking-wider" data-id="element-225">
              Satisfacción
            </div>
          </div>
          <div data-id="element-226">
            <div className="text-3xl md:text-4xl font-black text-gold mb-2" data-id="element-227">
              Top 3
            </div>
            <div className="text-sm text-gray-400 font-medium uppercase tracking-wider" data-id="element-228">
              Google Maps Garantizado
            </div>
          </div>
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-229">
          {testimonials.map((t, i) => <div key={i} className="bg-carbon border border-gray-800 p-8 rounded-sm relative" data-id="element-230">
              <div className="text-gold text-4xl font-serif absolute top-4 left-4 opacity-50" data-id="element-231">
                "
              </div>
              <p className="text-white text-lg relative z-10 mb-6 italic leading-relaxed pt-4" data-id="element-232">
                {t.quote}
              </p>
              <div data-id="element-233">
                <div className="font-bold text-gray-200" data-id="element-234">{t.author}</div>
                <div className="text-sm text-gray-500" data-id="element-235">{t.restaurant}</div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}